import { useSelector } from 'react-redux'
import { authSelector } from 'redux/authUser/selectors'
import { hasPermission } from './global/HelperFunctions'

type AuthProps = {
  children: JSX.Element
  isAuthorized?: boolean
  permission?: string
  targetEmployeeId?: number
}

const Auth = ({
  children,
  isAuthorized,
  targetEmployeeId,
  permission,
}: AuthProps): JSX.Element | null => {
  const { employee } = useSelector(authSelector)

  if (hasPermission(employee, targetEmployeeId, permission) || isAuthorized) {
    return children
  }

  return null
}

export default Auth
